import {nonUserAxios} from "../../common/NonUserAxios";

const ACTION_URL = '/sign';

const LOGIN_USER = ACTION_URL + '/in/media';
const LOGIN_ADMIN = ACTION_URL + '/in/admin';
const LOGOUT_USER = ACTION_URL + '/out/media';
const LOGOUT_ADMIN = ACTION_URL + '/out/admin';
const ADMIN_REFRESH_URL = '/admin/refresh-token/1';
const USER_REFRESH_URL = '/media/refresh-token/1';

const requestAuth = (method, url, data) => nonUserAxios.request({
  method,
  url,
  data,
});

/**
 * 유저 로그인 API
 * @param loginInfo
 * @returns {Promise<null>}
 */
export async function login(loginInfo) {
  let returnVal = null;
  await requestAuth('POST', LOGIN_USER, loginInfo)
    .then((response) => {
      const { data, statusCode } = response.data;
      if(statusCode === 200){
        returnVal = data;
        localStorage.removeItem("refreshToken")
        localStorage.setItem("refreshToken", data.token.refreshToken);
      }else{
        returnVal = false;
      }
    }).catch(() => returnVal = false)
  return returnVal;
}

/**
 * 사용자 로그아웃
 * @param userInfo
 * @returns {Promise<null>}
 */
export async function logOutUser(userInfo) {
  let returnVal = null;
  await requestAuth('POST', LOGOUT_USER, userInfo)
    .then((response) => {
      const { statusCode } = response.data;
      if(statusCode === 200){
        returnVal = true;
      }else{
        returnVal = false;
      }
    }).catch(() => returnVal = false)
  return returnVal;
}

/**
 * 관리자 로그인
 * @param loginInfo
 * @returns {Promise<null>}
 */
export async function loginAdmin(loginInfo) {
  let returnVal = null;

  await requestAuth('POST', LOGIN_ADMIN, loginInfo)
    .then((response) => {
      const { data, statusCode } = response.data;
      if(statusCode === 200){
        returnVal = data;
        localStorage.removeItem("refreshToken")
        localStorage.setItem("refreshToken", data.token.refreshToken);
      }else{
        returnVal = false;
      }
    }).catch(() => returnVal = false)
  return returnVal;
}

/**
 * 관리자 로그아웃
 * @param userInfo
 * @returns {Promise<null>}
 */
export async function logOutAdmin(userInfo) {
  let returnVal = null;
  await requestAuth('POST', LOGOUT_ADMIN, userInfo)
    .then((response) => {
      const { statusCode } = response.data;
      if(statusCode === 200){
        returnVal = true;
      }else{
        returnVal = false;
      }
    }).catch(() => returnVal = false)
  return returnVal
}


/**
 * 어드민 리프레쉬 토큰 api
 * @returns {Promise<null>}
 */
export async function refreshAdmin() {
  const param = {
    accessToken: '',
    refreshToken: localStorage.getItem("refreshToken"),
  }
  let returnVal = null;
  await requestAuth('POST', ADMIN_REFRESH_URL, param).then((response) => {
    const { data, statusCode } = response.data;
    if (statusCode === 200) {
      localStorage.removeItem("refreshToken");
      localStorage.setItem("refreshToken", data.token.refreshToken);
    }
    returnVal = response.data;
  }).catch(() => returnVal = false)
  return returnVal;
}

/**
 * 사용자 리프레쉬 토큰 api
 * @returns {Promise<*|null>}
 */
export async function refresh() {
  const param = {
    accessToken: '',
    refreshToken: localStorage.getItem("refreshToken"),
  }
  let returnVal = null;
  await requestAuth('POST', USER_REFRESH_URL, param).then((response) => {
    const { data,statusCode } = response.data;
    if (statusCode === 200) {
      localStorage.removeItem("refreshToken")
      localStorage.setItem("refreshToken", data.token.refreshToken);
      returnVal = response.data;
    } else if (statusCode === 401 || statusCode === 403) {
      returnVal = false;
    }
  }).catch(() => returnVal = false)
  return returnVal;
}
